import React, { Component } from 'react';
import { connect } from 'react-redux';
import Checkbox from '@mui/material/Checkbox';
import InputAdornment from '@mui/material/InputAdornment';
import FormControlLabel from '@mui/material/FormControlLabel';
import LOOKUP from 'constants/lookup';
import { selectEmployeeModel } from 'selectors/entitySelector';
import util from 'library/util';
import { employeeEditCrumb, employeeAddCrumb } from 'utils/breadcrumbInfo';
import { mapRoles } from 'utils/mappers';
import { clearFormInput, formInput } from 'actions/FormActions';
import { initializeEmployeeForm } from 'actions/FormActions';
import { getEmployee, saveEmployee, getRoles, getBranches, newPin, unlockAccount } from 'actions/EntityActions';
import { showError, showSnackbar } from 'actions/CommonActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import TextInput from 'screens/components/basic/TextInput';
import EmailInput from 'screens/components/basic/EmailInput';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import SelectInput from 'screens/components/basic/SelectInput';
import CheckInput from 'screens/components/basic/CheckInput';
import Grid from 'screens/components/basic/Grid';
import DecimalInput from 'screens/components/basic/DecimalInput';
// Advanced Components
import AddressInfo from 'screens/components/advanced/AddressInfo';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';

import WithRouter from 'custom/withRouter';

const name = "employee";

class EmployeeSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: ""
        };
        this.pwdRef = React.createRef();
        this.confirmPwdRef = React.createRef();

        this.generateNewPin = this.generateNewPin.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
    }

    // check if we have id in the URL
    componentWillMount() {
        this.props.getRoles();
        this.props.getBranches();
        const employeeId = this.props.params.id;
        // if true dispatch an action to retrive the data from API and set Status to EDIT
        if (employeeId) {
            this.setState({ status: "EDIT" });
            this.props.getEmployee(employeeId);
        }
        // if false dispatch an action to clean the form and set default values, Status to ADD
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.branchId);
        }
    }

    componentDidMount() {
        const pwd = this.pwdRef.current;
        if (pwd) {
            pwd.addEventListener("change", () => this.isPwdValid());
        }

        if (!this.props.canUpdateEmployee && this.props.params.id) {
            this.props.showError(LOOKUP.authentication.unauthorizedMessage);
            browserHistory.push('/employee');
        }
    }

    // check if the Save Success or SaveError happened
    componentWillReceiveProps(newProps) {
        if ((newProps.saveSuccess != undefined && newProps.saveSuccess !== this.props.saveSuccess)
            || (newProps.saveError != undefined && newProps.saveError !== this.props.saveError)) {
            //if does changed call the respective action (SUCCESS OR FAILURE)
            if (newProps.saveSuccess)
                this.saveSuccess();
            else
                this.saveFailure(newProps.saveError);
        }
    }

    componentWillUnmount() {
        this.props.clearFormInput("employeeBranch-" + this.props.branchId);
        this.props.clearFormInput(name + "HiredDate");
    }

    isPwdValid() {
        const pwd = this.pwdRef.current;
        if (pwd) {
            return /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{8,}/.test(this.props.employeePwd);
        }
        return true;
    }

    isPwdMatched() {
        if (this.props.employeePwdConfirm == this.props.employeePwd) {
            return true;
        }
        return false;
    }

    togglePwd() {
        const pwd = this.pwdRef.current;
        if (pwd && pwd.type){
            pwd.type = pwd.type === "password" ? "text" : "password";
        }
    }

    toggleConfirmPwd() {
        const confirmPwd = this.confirmPwdRef.current;
        if (confirmPwd && confirmPwd.type){
            confirmPwd.type = confirmPwd.type === "password" ? "text" : "password";
        }
    }

    // when data is saved successfully
    saveSuccess() {
        this.props.showSuccess(this.state.status === "EDIT" ? LOOKUP.employee.editedMessage : LOOKUP.employee.createdMessage);
        this.redirectToEmployeeList();
    }

    // when data is not saved, failure
    saveFailure(error) {
        //this.props.showError(LOOKUP.employee.saveErrorMessage);
        this.props.showError(error);
    }

    redirectToEmployeeList() {
        this.props.navigate("/employee");
    }

    validateAge(birthDate) {
        const actualDate = new Date();
        let years = (actualDate.getFullYear() - birthDate.getFullYear());

        if (actualDate.getMonth() < birthDate.getMonth() ||
            actualDate.getMonth() == birthDate.getMonth() && actualDate.getDate() < birthDate.getDate()) {
            years--;
        }

        return years >= this.props.ageLimit;
        //return years >= 21;
    }

    saveEmployee() {
        const p = this.props;
        let employee = this.props.employeeModel;

        let validators = [
            [name + 'FirstName', employee => (employee.FirstName && employee.FirstName !== null && employee.FirstName !== ""), "First Name"],
            [name + 'LastName', employee => (employee.LastName && employee.LastName !== null && employee.LastName !== ""), 'Last Name'],
            [name + 'Role', employee => (employee.Role && employee.Role !== null && employee.Role !== ""), "Role"],
            //[name + 'Birthdate', employee => (employee.DateOfBirth && employee.DateOfBirth !== null && employee.DateOfBirth !== ""), "Birth Date"],
            [name + 'Email', employee => (employee.Email && employee.Email !== null && employee.Email !== ""), "Email"],
            //[name + 'Phone', employee => (employee.Phone && employee.Phone !== null && employee.Phone !== "" && employee.Phone.length > 12), "Phone"],
            //[name + 'Address', employee => (employee.Address && employee.Address !== null && employee.Address !== ""), "Address"],
            //[name + 'Country', employee => (employee.Country && employee.Country !== null && employee.Country !== ""), "Country"],
            //[name + 'ProvinceState', employee => (employee.State && employee.State !== null && employee.State !== ""), "Province"],
            //[name + 'City', employee => (employee.City && employee.City !== null && employee.City !== ""), "City"],
            //[name + 'PostalCode', employee => (employee.PostalCode && employee.PostalCode !== null && employee.PostalCode !== "" && employee.PostalCode.length > 6), "Postal Code"]
        ];

        if (this.state.status === "ADD") {
            validators.push(
                [name + 'Password', employee => (employee.Password && employee.Password !== null && employee.Password !== ""), "Password"]);
        }

        if (util.validate(validators, employee, this.props.formError)) {
            if (!employee.Branches || employee.Branches.length === 0) {
                p.showError('Please, select at least one Branch that the employee will have access to.');
                return;
            }

            this.props.saveEmployee(employee);
        }
    }

    generateNewPin() {
        //this.props.newPin(this.props.name);
        this.props.newPin(name);
    }

    unlockAccount() {
        this.props.unlockAccount(this.props.employeeModel.Email);
    }

    handleSelectAll(event, value) {
        this.props.branches.map(item => {
            this.props.formInput(value, `${name}Branch-${item.id}`);
        })
    }

    render() {
        const p = this.props;
        const crumbs = this.state.status === 'EDIT' ? employeeEditCrumb : employeeAddCrumb;

        return (
            <Grid headerContent={crumbs}>
                <div title="Profile" className="editPage row">
                    {/* LEFT PANEL */}
                    <section className="col-xs-12 col-md-6 col-lg-6 pa-2">
                        {/* General Information */}
                        <div className="row">
                            <div className="col-xs-12">
                                <h4 className="profile-view-subtitle">General Information</h4>
                            </div>
                        </div>
                        {(this.state.status === 'EDIT')
                            ?
                            <div className="row">
                                <div className="col-lg-6 col-xs-6 d-flex pt-1">
                                    <div className="font-weight-700 mr-3 purpleText">ID</div>
                                    <div>{p.employeeModel.Id}</div>
                                </div>
                                <div className="col-lg-6 col-xs-12">
                                    <ToggleInput className="toggle-active-inactive btnToggleLabel" name={`${name}Status`} label="Status"
                                        option="Inactive" option2="Active"
                                    />
                                </div>

                            </div>
                            :
                            null
                        }
                        <div className="row">
                            <div className="col-lg-6">
                                <TextInput name={name + "FirstName"}
                                    label={LOOKUP.employee.firstname.label}
                                    floatingLabelText={LOOKUP.employee.firstname.label}
                                    hintText={LOOKUP.employee.firstname.hintText}
                                    fullWidth={true}
                                    maxLength={50}
                                    required />
                            </div>
                            <div className="col-lg-6">
                                <TextInput name={name + "LastName"}
                                    label={LOOKUP.employee.lastname.label}
                                    floatingLabelText={LOOKUP.employee.lastname.label}
                                    hintText={LOOKUP.employee.lastname.hintText}
                                    fullWidth={true}
                                    maxLength={50}
                                    required />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <DatePickerInput name={name + "Birthdate"}
                                    label={LOOKUP.employee.birthdate.label}
                                    floatingLabelText={LOOKUP.employee.birthdate.label}
                                    hintText={LOOKUP.employee.birthdate.hintText}
                                    fullWidth={true}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <SelectInput name={name + "Role"}
                                    fullWidth={true}
                                    floatingLabelText={LOOKUP.employee.role.label}
                                    label={LOOKUP.employee.role.label}
                                    hintText={LOOKUP.employee.role.hintText}
                                    options={mapRoles(this.props.rolesList.filter(item => item.isVisible))}
                                    required
                                />
                            </div>
                            <div className="col-lg-6">
                                <DecimalInput name={name + "HourlyRate"}
                                    fullWidth={true}
                                    min={0}
                                    floatingLabelText={LOOKUP.employee.HourlyRate.label}
                                    label={LOOKUP.employee.HourlyRate.label}
                                    hintText={LOOKUP.employee.HourlyRate.hintText}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <TextInput name={name + "SIN"}
                                    fullWidth={true}
                                    floatingLabelText={LOOKUP.employee.SIN.label}
                                    label={LOOKUP.employee.SIN.label}
                                    hintText={LOOKUP.employee.SIN.hintText}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <DatePickerInput name={name + "HiredDate"}
                                    fullWidth={true}
                                    floatingLabelText={LOOKUP.employee.HiredDate.label}
                                    label={LOOKUP.employee.HiredDate.label}
                                    hintText={LOOKUP.employee.HiredDate.hintText}
                                />
                            </div>
                        </div>
                    </section>

                    {/* RIGHT PANEL */}
                    <section className="col-xs-12 col-md-6 col-lg-6 pa-2 editInfo">
                        {/* Contact Information */}
                        <div className="row">
                            <div className="col-xs-12">
                                <h4 className="profile-view-subtitle">Contact Information</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                {(this.state.status === "ADD")
                                    ?
                                    <EmailInput name={name + "Email"}
                                        label={LOOKUP.employee.email.label}
                                        floatingLabelText={LOOKUP.employee.email.label}
                                        hintText={LOOKUP.employee.email.hintText}
                                        maxLength={60}
                                        fullWidth={true} />
                                    : <EmailInput name={name + "Email"}
                                        label={LOOKUP.employee.email.label}
                                        floatingLabelText={LOOKUP.employee.email.label}
                                        hintText={LOOKUP.employee.email.hintText}
                                        maxLength={60}
                                        fullWidth={true}
                                        disabled={true} />
                                }
                            </div>
                            <div className="col-lg-12">
                                <MaskedTextInput
                                    fullWidth={true}
                                    name={`${name}Phone`}
                                    floatingLabelText={LOOKUP.vendor.phone.label}
                                    hintText={LOOKUP.vendor.phone.hintText}
                                    maxLength={13}
                                    mask="(999)999-9999" />
                            </div>
                            <AddressInfo name={name} />
                        </div>
                        <br />
                        <br />
                        {this.props.employeeModel.AccountLockedOut &&
                            <div className="row p-2 ">
                                <Button name="buttonUnLock"
                                    className="btnNewBrandPOS"
                                    label={"Unlock User Account"}
                                    primary={true}
                                    onTouchTap={() => this.unlockAccount()} />
                            </div>
                        }
                    </section>

                    {/* BRANCH PANEL */}
                    <section className="col-xs-12 pt-2 border-top-purple">
                        <div className="row">
                            <div className="col-lg-12">
                                <label className="purpleText ptb-1">Select which Branch the employee will have access to:</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12 mb-1">
                                {/* <Checkbox label="Select All" text="Select All" name="selectAll" onCheck={this.handleSelectAll} /> */}

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            label="Select All" text="Select All" name="selectAll"
                                            onChange={this.handleSelectAll}
                                        />
                                    }
                                    label="Select All"
                                    labelPlacement="end"
                                    sx={{ textAlign: 'left', labelStyle: { textAlign: 'left' } }}
                                />
                            </div>
                            {
                                p.branches.map((item, index) => {
                                    return (
                                        <div className="col-lg-4
                                        " key={index}>
                                            <CheckInput name={`${name}Branch-${item.id}`}
                                                text={item.name}
                                                className="checkBoxLabels"
                                            />
                                        </div>
                                    );
                                })
                            }
                        </div>
                    </section>

                    {/* LOGIN PANEL */}
                    <section className="col-xs-12 pt-2 border-top-purple">
                        {(this.state.status === "ADD")
                            ?
                            <div title="Login Info">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <h4 className="profile-view-subtitle">Login Information</h4>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <EmailInput name={name + "Email"}
                                            label={LOOKUP.employee.email.label}
                                            floatingLabelText={LOOKUP.employee.email.label}
                                            hintText={LOOKUP.employee.email.hintText}
                                            inputStyle={{ fontWeight: "bold", fontSize: 20 }}
                                            maxLength={60}
                                            fullWidth={true}
                                            disabled={true} />
                                    </div>
                                </div>
                                <div className="row">
                                    {/* New Password */}
                                    <div className="col-lg-6">
                                        <TextInput 
                                            inputRef={this.pwdRef}
                                            name={name + "Password"}
                                            id={name + "Pwd"}
                                            type={"password"}
                                            label="New Password"
                                            floatingLabelText="New Password"
                                            hintText="New Password"
                                            maxLength={20}
                                            fullWidth={true} 
                                            endAdornment={
                                                <InputAdornment position="end" onClick={() => this.togglePwd()}>
                                                    <i className="fa fa-eye pull-left employee_password_toggle" aria-hidden="true" />
                                                </InputAdornment>
                                            }
                                        />
                                        {
                                            (this.props.employeePwd == "" || this.isPwdValid())
                                                ? "" : <div className="pwd_validation"><span className="employee_password_validation">Password does not match the requirements</span></div>
                                        }
                                        {/* .pw_msg */}
                                        <div className="pw_msg">
                                            <p>Password must:</p>
                                            <div>
                                                <li>Have between 8 and 20 characters</li>
                                                <li>Contain at least a number</li>
                                                <li>Contain at least a uppercase character</li>
                                                <li>Contain at least a special character</li>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Confirm Password */}
                                    <div className="col-lg-6">
                                        <TextInput 
                                            inputRef={this.confirmPwdRef}
                                            name={name + "ConfirmPassword"}
                                            id={name + "PwdConfirm"}
                                            type={"Password"}
                                            label="Confirm Password"
                                            floatingLabelText="Confirm Password"
                                            hintText="Confirm Password"
                                            maxLength={20}
                                            fullWidth={true} 
                                            endAdornment={
                                                <InputAdornment position="end" onClick={() => this.toggleConfirmPwd()}>
                                                    <i className="fa fa-eye pull-left employee_password_toggle" aria-hidden="true" />
                                                </InputAdornment>
                                            }
                                        />
                                        {
                                            this.props.employeePwdConfirm == undefined || this.props.employeePwdConfirm == ""
                                                ? "" : this.props.employeePwd == "" && this.props.employeePwdConfirm
                                                    ? <div className="pwd_validation"><span className="employee_password_validation">Please enter the new password first</span></div> : this.isPwdMatched()
                                                        ? "" : <div className="pwd_validation"><span className="employee_password_validation">Password does not match</span></div>
                                        }
                                    </div>
                                </div>
                            </div>
                            :
                            this.props.isPinEnabled &&
                            (
                                <div title="Reset Pin Password" className="p-3">
                                    <h4 className="profile-view-subtitle d-block purpleText">Reset Pin Password</h4>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <TextInput name={name + "Pin"}
                                                id={name + "pinpwd"}
                                                label="New Pin Password"
                                                floatingLabelText="New Pin Password"
                                                hintText="New Pin Password"
                                                maxLength={4}
                                                fullWidth={true}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="col-lg-2 mt-2" >
                                            <Button name="generatePin"
                                                label={"Generate Pin"}
                                                primary={true}
                                                onTouchTap={this.generateNewPin}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </section>

                    {/* BUTTONS PANEL */}
                    <section className="row">
                        <div className="col-xs-12 mb-2">
                            <Button
                                name="buttonSave"
                                className="pull-right btnNewBrandPOS"
                                label={LOOKUP.employee.controls.saveButton}
                                primary={true}
                                onTouchTap={() => this.saveEmployee()}
                                disabled={!this.isPwdValid()}
                            />
                            <Button
                                type="CancelButton"
                                name="buttonCancel"
                                className="pull-right btn-space btnCancelOperation"
                                label={LOOKUP.common.cancel.text}
                                onTouchTap={() => this.redirectToEmployeeList()}
                            />
                        </div>
                    </section>
                </div>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return {
        employeeModel: selectEmployeeModel(state, "employee"),
        rolesList: state.entity.rolesList || [],
        saveSuccess: state.form["employee" + "SaveSuccess"],
        saveError: state.form["employee" + "SaveError"],
        branches: state.entity.branches || [],
        branchId: state.common.branchId,
        ageLimit: state.common.applicationSettings.ageValidation,
        employeePwd: state.form["employee" + "Password"],
        employeePwdConfirm: state.form["employee" + "ConfirmPassword"],
        isPinEnabled: state.common.applicationSettings.enablePinPasswordOnPOS,
        canUpdateEmployee: state.common.authenticatedUser.claims && state.common.authenticatedUser.claims.some(claim => claim && claim.includes("CanUpdateEmployee"))
    };
}

function mapDispatchToProps(dispatch) {
    return {
        init: (branchId) => dispatch(initializeEmployeeForm("employee", branchId)),
        getRoles: () => dispatch(getRoles()),
        getEmployee: (id) => dispatch(getEmployee({ id, compName: "employee" })),
        showSuccess: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        saveEmployee: (employee) => dispatch(saveEmployee(employee, "employee")),
        getBranches: () => dispatch(getBranches()),
        newPin: (compName) => dispatch(newPin(compName)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        unlockAccount: (model) => dispatch(unlockAccount(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(EmployeeSave));
